import AxiosService from './AxiosService';
import {useBagStore} from '../store/BagStore';

/** Onde o pedido sugerido foi usado para encher a sacola. */
export type SuggestedFillSource = 'bag_auto' | 'home_carousel';

export interface SuggestedFillItem {
  sku: string;
  quantity: number;
}

/**
 * Pedido sugerido — grava no back o retrato do que foi sugerido e guarda o id
 * na sacola. O checkout manda esse id em `X-Suggested-Fill-Id`, e o back marca
 * o pedido como vindo do sugerido (inteiro ou em parte).
 *
 * Nunca lança: é rastreio. Se falhar, o pedido só sai sem a marca.
 */
const registerSuggestedFill = async (
  clientCode: string | undefined,
  source: SuggestedFillSource,
  items: SuggestedFillItem[],
): Promise<void> => {
  const validItems = items.filter(item => item.sku && item.quantity > 0);

  if (!clientCode || validItems.length === 0) {
    return;
  }

  try {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.post(
      '/suggested-fills',
      {
        client_code: clientCode,
        source,
        items: validItems.map(item => ({
          sku: String(item.sku),
          quantity: Math.floor(item.quantity),
        })),
      },
      {headers: {'Content-Type': 'application/json'}},
    );

    const id = response.data?.id;
    // Sacola esvaziada enquanto a chamada estava no ar: não marca.
    if (id && useBagStore.getState().products.length > 0) {
      useBagStore.getState().setSuggestedFillId(id);
    }
  } catch (error) {
    console.error('Erro ao registrar o pedido sugerido:', error);
  }
};

export default {
  registerSuggestedFill,
};
